import { useState, useEffect } from 'react';
import axios from 'axios';
import './Principal.css';
import CONFIG from '../../config.js';
import { useNavigate } from "react-router-dom";
import CalendarioResumenEventos from '../mensajes/CalendarioResumenEventos.js';


const URL_INFO = `${CONFIG.API_URL}/info_principal.php`;
const URL_CALENDARIO = `${CONFIG.API_URL}/operarCalendario.php`;

function PrincipalDocentes({ mensajesSinLeer, rol, configuracion }) {

    const [cursosArr, setCursosArr] = useState([]);
    const userId =localStorage.getItem('loggedUserId');
    const [eventos, setEventos] = useState([]);
    const loggeduserId =localStorage.getItem('loggedUserId');
    const navigate = useNavigate();
    const fecha = new Date();
    const cicloActual = fecha.getFullYear();

    useEffect(() => {
        buscaInfo();
        obtenerEventos();
    }, []);

    const buscaInfo = () => {
        axios.get(`${URL_INFO}?id_usiario=${loggeduserId}&ciclo=${cicloActual}`)
            .then(res => {
                if (res.data.usuarios) { 
                    // Asumiendo que la API retorna estos datos
                    setCursosArr(res.data.arregloCursos);
                    console.log('arregloCursos:', res.data.arregloCursos);
                } else {

                    setCursosArr([]);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

   const obtenerEventos = async () => {
        try {
            const res = await axios.get(`${URL_CALENDARIO}?id_usiario=${loggeduserId}`);
            console.log("eventos:"+JSON.stringify(res.data));
            if (Array.isArray(res.data)) {
                // Aplicar filtros según el rol
                const eventosFiltrados = res.data.filter(evento => {
                    const esPropio = evento.creada_por == userId;
                    
                let filtroPorRol = false;
                rol = parseInt(rol, 10);
                switch (rol) {
                        case 1:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 2:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 3:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 4:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 5:
                            filtroPorRol = ['todos', 'todosD', 'todosDC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            break;
                        case 6:
                            filtroPorRol = ['todos', 'todosD', 'todosDC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            break;
                        case 7:
                            filtroPorRol = ['todos', 'todosE', 'todosEC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            //console.log('rol 7, evento:', evento.tipo_recordatorio, 'filtroPorRol:', filtroPorRol);
                            break;
                        case 8:
                            filtroPorRol = ['todos', 'todosT','todosE', 'todoTC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            break;
                        case 9:
                            filtroPorRol = ['todos', 'todosD'].includes(evento.tipo_recordatorio);
                            break;
                        case 12:
                            filtroPorRol = ['todos', 'todosM'].includes(evento.tipo_recordatorio);
                            break;
                        default:
                            filtroPorRol = false;
                            break;
                    }
    
                    return esPropio || filtroPorRol;
                });

                setEventos(eventosFiltrados);
            } else {
                setEventos([]);
                console.error('La respuesta de la API no es un array:', res.data);
            }
        } catch (err) {
            console.error('Error al obtener eventos:', err);
        }
    };

    const mostrarNombre = (orden)=>{
        let nombre="";
        switch(orden){  
          case "S2":
            nombre='Sala de 2';
            break        
          case "S3":
            nombre='Sala de 3';
          break
          case "S4":
            nombre='Sala de 4';
          break
          case "S5":
            nombre='Sala de 5';
          break
          case "In":
            nombre='Espacio Institucional';
          break
          default:
            nombre=orden+'°';
        }
        return nombre
      };

    const entrarEnCurso =(cur)=>{
        localStorage.setItem('loggeduserCurso', cur.id );
        localStorage.setItem('loggeduserCursoGrupo',  cur.id_curso_grupo);
        localStorage.setItem('loggeduserCursoGrupoO',  JSON.stringify(cur));
        navigate(`/MC/${cur.id}`);
    }
    return (    
        <div>
            <h5>Área docente </h5>
            <div className='row'>
                <div className='col-12 col-md-6 col-lg-4'>
                    <div className='card px-2'>
                        <div className="principal-card" style={{backgroundColor:configuracion.fondo_barra_lateral}}>
                            <div className='principal-caja-circulo-logo' style={{backgroundColor: configuracion.color_secundario, color:configuracion.color_terciario}}><i className='fa-solid fa-envelope'></i></div>
                            <div className='principal-caja-borde-logo'
                                style={{background: configuracion.color_secundario}}>
                            </div>
                            <div className='principal-card-titulo' style={{backgroundColor:configuracion.color_principal, color: configuracion.color_terciario}}>Mensajes sin leer</div>
                            <div className='d-flex justify-content-center principal-texto-info-rojo' style={{color: configuracion.color_principal}}>{mensajesSinLeer}</div>
                        </div>

                        <div className=''>
                            <CalendarioResumenEventos userId={userId} rol={rol} eventos={eventos} />
                        </div>
                                    
                    </div>
                </div>
                
                <div className='col-12 col-md-6 col-lg-8'>
                    <div className='card px-2'>
                        <h4>Eres docente en {cursosArr.length} {cursosArr.length==1? 'curso': 'cursos'}</h4>
                        <div className='d-flex flex-wrap'>
                        {cursosArr.map((c)=>(
                            <div key={c.id} onClick={() => entrarEnCurso(c)}>
                                <div className='cuadro-info-simple' style={{
                            background:configuracion.color_secundario,
                            background: `linear-gradient(266deg,${configuracion.color_secundario} 0%, ${configuracion.color_principal} 100%, ${configuracion.color_terciario} 100%)`}}>
                                    <div className='texto-info1' style={{color: configuracion.color_terciario}}>
                                        <i className="wrap-icon fa-solid fa-box-archive mr-3"></i>{mostrarNombre(c.orden)} 
                                    </div>
                                    <div className='texto-info1'  style={{color: configuracion.color_terciario}}>
                                        grupo "{c.denominacion}"  - {c.cohorte}
                                    </div>
                                </div>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default PrincipalDocentes;
